export const GUEST_QA_SECTION_DOC_ID = "guestQA";
export const GUEST_QA_PAGE_TITLE = "Guest Q&A";
export const GUEST_QA_DISPLAY_TITLE = "Q&A";

function isGuestQATitle(title) {
  const normalized = (title || "").trim().toLowerCase();
  return (
    normalized === GUEST_QA_PAGE_TITLE.toLowerCase() ||
    normalized === GUEST_QA_DISPLAY_TITLE.toLowerCase()
  );
}

export function adminGuestQAManageUrl(propertyId) {
  const id = encodeURIComponent(String(propertyId || ""));
  const host =
    typeof window !== "undefined" ? window.location.hostname : "";
  const origin =
    host === "localhost" || host === "127.0.0.1"
      ? "http://localhost:5001"
      : "https://manage.everhost.io";
  return `${origin}/?search=${id}&guestQA=1`;
}

export function hasGuestQAPropertyField(property) {
  const guestQA = property?.guestQA;
  return typeof guestQA === "string" && guestQA.trim().length > 0;
}

export function hasGuestQAContent(property) {
  if (!hasGuestQAPropertyField(property)) {
    return false;
  }
  return /<h3\b[^>]*>[\s\S]*?<\/h3>/i.test(property.guestQA);
}

export function isGuestQAMenuItem(item) {
  if (!item || typeof item !== "object") {
    return false;
  }

  if (item.section === GUEST_QA_SECTION_DOC_ID) {
    return true;
  }

  if (item.docId === GUEST_QA_SECTION_DOC_ID) {
    return true;
  }

  if ((item.id || "").toString().toLowerCase() === "guestqa") {
    return true;
  }

  const title = (item.label || item.pageTitle || "").trim().toLowerCase();
  return isGuestQATitle(title);
}

export function isGuestQASubsection(section) {
  if (!section || typeof section !== "object") {
    return false;
  }

  const docId = (section.docId || "").toString();
  if (docId === GUEST_QA_SECTION_DOC_ID) {
    return true;
  }

  const title = (section.pageTitle || section.label || "")
    .trim()
    .toLowerCase();
  return isGuestQATitle(title);
}

export function dedupeGuestQASubsectionsInList(sections) {
  const guestIndices = [];
  sections.forEach((section, index) => {
    if (isGuestQASubsection(section)) {
      guestIndices.push(index);
    }
  });

  if (guestIndices.length <= 1) {
    return sections.map((section) => ({
      ...section,
      docId: isGuestQASubsection(section)
        ? GUEST_QA_SECTION_DOC_ID
        : section.docId,
    }));
  }

  const keepIndex =
    guestIndices.find(
      (index) => sections[index].docId === GUEST_QA_SECTION_DOC_ID,
    ) ?? guestIndices[0];

  return sections
    .filter((section, index) => {
      if (!isGuestQASubsection(section)) {
        return true;
      }
      return index === keepIndex;
    })
    .map((section) => ({
      ...section,
      docId: isGuestQASubsection(section)
        ? GUEST_QA_SECTION_DOC_ID
        : section.docId,
    }));
}

export function sortSubsectionsByOrder(sections) {
  return [...sections].sort(
    (a, b) => Number(a.sortOrder || 0) - Number(b.sortOrder || 0),
  );
}

export function hasGuestQASubsection(sections) {
  return sections.some((section) => isGuestQASubsection(section));
}

export function getSectionContent(property, section) {
  if (!property || !section) {
    return "";
  }

  if (isGuestQASubsection(section)) {
    if (property.guestQA) {
      return property.guestQA;
    }
    const legacyKey = section.subsectionKey;
    if (legacyKey && property[legacyKey]) {
      return property[legacyKey];
    }
    if (section.docId && property[section.docId]) {
      return property[section.docId];
    }
    return "";
  }

  // Content lives on the property document under docId (e.g. "description").
  // subsectionKey is only the Firestore map key (often "0", "1", ...).
  if (section.docId && property[section.docId]) {
    return property[section.docId];
  }
  if (section.subsectionKey && property[section.subsectionKey]) {
    return property[section.subsectionKey];
  }
  return "";
}
